import { render, staticRenderFns } from "./fieldscontact.vue?vue&type=template&id=696e731e&lang=pug"
import script from "./fieldscontact.vue?vue&type=script&lang=js"
export * from "./fieldscontact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports